import { render, staticRenderFns } from "./LayoutPassword.vue?vue&type=template&id=2e03db76&"
import script from "./LayoutPassword.vue?vue&type=script&lang=js&"
export * from "./LayoutPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports